<template>
    <div>
        Invoices page
    </div>
</template>

<script>
    export default {
        name: 'Invoices',
        data() {
            return {}
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Reports/Payments/Invoices.vue